<template>
  <div class="zoom-copy-modal-component">
    <div class="d-flex align-items-start">
      <div class="flex-fill">
        <h4 class="title">Integração Zoom</h4>
        <a href="https://zoom.us/" target="_blank" class="link">
          Conheça o Zoom <i class="fa fa-external-link"></i>
        </a>
      </div>
      <button
        class="btn btn-sm btn-square"
        type="button"
        @click="$emit('close')"
      >
        <i class="icon-x fs-20 text-secondary" />
      </button>
    </div>

    <div class="p-6">
      <h5 class="title text-center mb-6">
        Qual integração deseja copiar?
      </h5>
      <div class="row align-items-center">
        <div class="col-1"></div>
        <div class="text col-4 col-lg-5">PRODUTO</div>
        <div class="text col-3">CLIENT_ID</div>
        <div class="text col-3">CLIENT_SECRET</div>
      </div>
      <hr class="mt-0" />
      <div class="integration-wrapper mb-5">
        <div
          v-for="(int, i) in all_zoom_integrations"
          :key="`integration-cp-${i}`"
          class="row align-items-center"
        >
          <div class="col-1 text-truncate">
            <b-form-radio v-model="integration_to_copy" :value="int.id" />
          </div>
          <div class="text col-4 col-lg-5 text-truncate">
            {{ PRODUCT_MAP[int.product_id] }}
          </div>
          <div class="text col-3 text-truncate">{{ int.client_id }}</div>
          <div class="text col-3 text-truncate">{{ int.client_secret }}</div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn-sm btn-new-primary font-weight-semibold btn-40 py-0 px-5"
          @click="toCopy"
        >
          Copiar
        </button>
      </div>
      <form @submit.prevent="$emit('submit')">
        <form-group
          v-model="form.client_id"
          id="client_id"
          label="Client_id"
          type="text"
          placeholder="Ex: C1NOtE62TzSaOvQPb4wl3w"
          :errors="errors.client_id"
        />
        <form-group
          v-model="form.client_secret"
          id="client_secret"
          label="Client_secret"
          type="text"
          placeholder="Ex: kgUEHSdyQj1hhyClbAEzyME95Lo3xXV0"
          :errors="errors.client_secret"
          class="mb-6"
        />

        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-sm btn-new-secondary font-weight-semibold btn-40 py-0 px-5 mr-6"
            @click="$emit('close')"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn-sm btn-new-primary font-weight-semibold btn-40 py-0 px-5"
            @click="$emit('submit')"
          >
            <b-spinner v-if="loading" variant="light" small></b-spinner>
            <span v-else>Integrar</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["form", "errors", "loading"],
  data() {
    return {
      step: 0,
      integration_to_copy: null
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["all_zoom_integrations"]),
    PRODUCT_MAP() {
      return this.products.reduce((a, c) => ({ ...a, [c.id]: c.name }), {});
    }
  },
  methods: {
    toCopy() {
      const int = this.all_zoom_integrations.find(
        i => i.id == this.integration_to_copy
      );

      this.form.client_id = int.client_id;
      this.form.client_secret = int.client_secret;
    }
  }
};
</script>
<style lang="scss" scoped>
.zoom-copy-modal-component {
  .title {
    color: var(--l-neutral-45);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }
  .link {
    color: rgba(153, 85, 255, 0.87);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .btn-integration {
    padding: 0;
    margin: 0;
    &:hover {
      background-color: #99999950;
    }
  }

  .text {
    @media screen and (max-width: 540px) {
      font-size: 12px;
    }
  }

  .integration-wrapper {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 100px;

    &::-webkit-scrollbar {
      background-color: transparent;
      border-radius: 0 7px 7px 0;
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 3px;
      background-color: #bf96fd;
      border-radius: 4px;
    }
  }
}
</style>
